import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { Panel } from "../../shared/interfaces/SurveyableAsset";

export function usePanelUpdate(callbacks?: QueryCallbacks<undefined>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["panelUpdate"],
    async (panel: Panel) => apiContext.hvSubstationApis.updateHvSurveyableChildAsset(panel),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
